import { Injectable } from '@angular/core';
import { HttpBackend, HttpClient } from '@angular/common/http';
import { environment } from '../../../../../environments/environment';
import { Observable } from 'rxjs';

@Injectable()
export class AuthorizeService {

  private apiUrl: string = environment.rest.apiV2Url;
  private client: HttpClient;

  constructor(private httpBackend: HttpBackend) {
    this.client = new HttpClient(httpBackend); // Bypass interceptors
  }

  public authorize(username: string, password: string): Observable<any> {
    const url = `${this.apiUrl}/auth/login`;

    return this.client.post(url, { username: username, password: password });
  }
}
